module.exports = __webpack_public_path__ + "static/media/PATS_3-1690w.1d92f17b.png";